import axios from '../util/axiosConfig';
import { getErrorMessage } from '../util/ErrorUtils';


export const fetchQuickCodesAPI = async (payload = {}) => {
    let data = {
        ...payload,
        page: Math.max(0, (payload.page || 1) - 1),
    }
  return await axios
    .post(`/api/v1/quick-codes`, data)
    .then(function (response) {
      if (response.data) {
        return { success: true, data: response.data };
      } else {
        return { success: false };
      }
    })
    .catch(function (error) {
      return { success: false };
    });
};

export const addUpdateQuickCodesAPI = async (user) => {
    return await axios.post(`/api/v1/add-update-quick-code`, user)
        .then(function (response) {
            if (response.data) {
                return { success: true, user: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const fetchQuickCodesbyIdAPI = async (quickCodeId) => {
    return await axios.get(`/api/v1/fetch-quick-code/${quickCodeId}`, {
        params: {
            'quickCodeId': quickCodeId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, accountInfo: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const searchQuickCodes = async (query) => {
  return await axios
    .get(`/api/v1/quick-codes/search`, {
      params: { query },
    })
    .then(function (response) {
      if (response.data) {
        return { success: true, data: response.data };
      } else {
        return { success: false };
      }
    })
    .catch(function (error) {
      return { success: false, error };
    });
};